import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

import {
  APP_ENV,
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  SERVICE_VERSION,
  DATADOG_ENABLED,
  BASE_URL,
} from './config'

// Chrome reports this when MUI's autosizing multiline fields finish laying out a frame late; nothing breaks.
const isResizeObserverLoopError = (message: string) => message.includes('ResizeObserver loop')

/**
 * Initialize Datadog for RUM and logging
 */
export const useInitDatadog = () => {
  useEffect(() => {
    if (DATADOG_ENABLED && DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN) {
      datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID,
        clientToken: DATADOG_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'lucian-crm',
        env: APP_ENV === 'dev' ? 'development' : APP_ENV,
        version: SERVICE_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        traceSampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask',
        allowedTracingUrls: [BASE_URL],
        // The API's CORS allow-list has no `baggage` header, so sending one fails every preflight.
        propagateTraceBaggage: false,
        beforeSend: event =>
          !(event.type === 'error' && isResizeObserverLoopError(event.error.message)),
      })
      datadogLogs.init({
        clientToken: DATADOG_CLIENT_TOKEN,
        site: 'datadoghq.com',
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error'],
        sessionSampleRate: 100,
        env: APP_ENV === 'dev' ? 'development' : APP_ENV,
        service: 'lucian-crm',
        version: SERVICE_VERSION,
        telemetrySampleRate: 0,
        beforeSend: log => !isResizeObserverLoopError(log.message),
      })
    }
  }, [])
}
